module.exports = __webpack_public_path__ + "static/media/tyre-red-three1.6302cfe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-red-three1.png
// module id = 336
// module chunks = 0